export enum PatientTypeEnum {
  PALLIATIVE,
  CHRONIC,
  NONE,
}

export const translateKey = (value: string): string => {
  return "patientType." + value.toLowerCase();
};

export const allPatientTypes = () => {
  return [
    PatientTypeEnum.PALLIATIVE,
    PatientTypeEnum.CHRONIC,
    PatientTypeEnum.NONE,
  ];
};
